<template>
  <div class="text">
    <transition-group appear name="slide-fade">
      <div :key="0" class="columns is-multiline">
        <div class="column is-two-thirds-desktop is-full-width-tablet icon-columns">
          <h1 class="title">{{ $prismic.richTextAsPlain(slice.primary.text_headline) }}</h1>
          <prismic-rich-text :field="slice.primary.text_content"/>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'TextSlice',
  props: ['slice']
}
</script>

<style>

</style>
